import { IMenuCategory } from 'O3_core';
import { StructureSMIs } from 'O3_structure';
import { SystemCatalogsSMIs } from 'O3_system-catalogs';
import { FinancialsSMIs } from 'O3_financials';
import { PatientManagementSMIs } from 'O3_patient-management';
import { ReferralSourcesSMIs, SchedulerSMIs } from 'O3_scheduler';
import { ChemotherapySMIs } from 'O3_chemotherapy';
import {
  StockManagementSMIs,
  StockManagementDepartmentSMIs,
} from 'O3_stock-management';
import { RadiotherapySMIs } from 'O3_radiotherapy';
import { OncologyCatalogsSMIs } from 'O3_oncology-catalogs';
import { CnasSMIs } from 'O3_cnas';
import { FileStorageSMIs } from 'O3_file-storage';
import { PathologicalAnatomySMIs } from 'O3_pathological-anatomy';
import { TemplateManagerSMIs } from 'O3_template-manager';
import { CommunicationSMIs } from 'O3_communication';
import { environment } from '../../environments/environment';
import { JobSchedulerSMIs } from 'O3_job-scheduler';
import { NotificationsSMIs } from 'O3_notifications';
import { IdentitySMIs } from 'O3_identity';
import { ReportingResourceSMIs } from 'O3_reporting';
import { AuditSMIs } from 'O3_audit';
import { SupportMyTicketsSMIs, SupportSMIs } from 'O3_support';

export const sidebarMenuItems: IMenuCategory[] = [
  {
    label: 'sideMenuCategories.dailyOperations',
    items: [
      ...ReportingResourceSMIs,
      ...PatientManagementSMIs,
      ...SchedulerSMIs,
      ...CommunicationSMIs,
      ...ReferralSourcesSMIs,
      // Gated on `support.ticket:SideMenuItem` since the UI scopes rollout;
      // that scope belongs on every role, since anyone can file a ticket.
      ...SupportMyTicketsSMIs,
    ],
  },
  {
    label: 'sideMenuCategories.billingFinance',
    items: [
      ...(environment.featureFlags['cnas'] ? CnasSMIs : []),
      ...(environment.featureFlags['finance'] ? FinancialsSMIs : []),
    ],
  },
  {
    label: 'sideMenuCategories.clinicalModules',
    items: [
      ...ChemotherapySMIs,
      ...RadiotherapySMIs,
      ...OncologyCatalogsSMIs,
      ...(environment.featureFlags['pathologicalAnatomy']
        ? PathologicalAnatomySMIs
        : []),
      ...TemplateManagerSMIs,
    ],
  },
  {
    label: 'sideMenuCategories.medicalLogistics',
    items: [
      ...(environment.featureFlags['stockManagement']
        ? StockManagementSMIs
        : []),
      ...(environment.featureFlags['stockManagement']
        ? StockManagementDepartmentSMIs
        : []),
    ],
  },
  {
    label: 'sideMenuCategories.supportAdmin',
    items: [
      ...SystemCatalogsSMIs,
      ...StructureSMIs,
      ...FileStorageSMIs,
      ...IdentitySMIs,
      ...AuditSMIs,
      ...(environment.featureFlags['jobScheduler'] ? JobSchedulerSMIs : []),
      ...NotificationsSMIs,
      ...SupportSMIs,
    ],
  },
];
